import React, { useState } from 'react'
import { Spin, message } from 'antd'
import Modal from 'meinian-package/src/component/modal'
import emptyImg from 'image/empty/empty_card_logo.png'
import SimpleTable from 'privateComponent/simpleTable'
import { request } from 'meinian-package/src/utils'
import { MEMBER_TYPE_NAME } from 'view/common/authEnum'
import useAsyncLoading from 'common/hooks/useAsyncLoading'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import styles from './index.module.less'

const columns = ({ params, authEditChecked, authDeleteChecked, onAuthChange, onAuthAll, isFolder }) => {
  return [
    { title: '成员',
      dataIndex: 'userName',
      width: 160,
      key: 'userName',
      render: (h, record) => {
        return <div className="mn-table-td-user-name">
          <img src={record?.targetUserInfo?.avatar || emptyImg} className="mn-table-td-head-portrait" />
          <div className="mn-table-td-user-name-text text-overflow">{record.targetUserInfo.userName}</div>
        </div>
      }
    },
    { title: '角色',
      dataIndex: 'memberType',
      width: 140,
      key: 'memberType',
      render: (h, record) => {
        return MEMBER_TYPE_NAME?.[record.targetUserInfo.memberType]
      }
    },
    {
      title: `${isFolder ? '创建、编辑文件夹' : '操作、编辑'}`,
      dataIndex: 'authEdit',
      width: 144,
      key: 'authEdit',
      render: (h, record) => {
        const disabled = record.targetUserInfo.memberType === 1 || record.targetUserInfo.memberType === 2
        const checked = record.targetUserInfo.memberType === 1
        || record.targetUserInfo.memberType === 2 || params.authEdit.some(item => item === record.targetUserInfo.userId)
        return <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(e) => onAuthChange(e.target.checked, record.targetUserInfo.userId, 'authEdit')}
        />
      },
      footer: {
        render: () => {
          return <div className="df-center">
            <Checkbox checked={authEditChecked} onChange={(e) => onAuthAll(e.target.checked, 'authEdit')} />
            <span style={{ marginLeft: '8px' }}>全选</span>
          </div>
        }
      }
    },
    {
      title: `${isFolder ? '移动、删除文件夹' : '移动、删除'}`,
      dataIndex: 'authDelete',
      width: 144,
      key: 'authDelete',
      render: (h, record) => {
        const disabled = record.targetUserInfo.memberType === 1 || record.targetUserInfo.memberType === 2
        const checked = record.targetUserInfo.memberType === 1
        || record.targetUserInfo.memberType === 2 || params.authDelete.some(item => item === record.targetUserInfo.userId)
        return <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(e) => onAuthChange(e.target.checked, record.targetUserInfo.userId, 'authDelete')}
        />
      },
      footer: {
        render: () => {
          return <div className="df-center">
            <Checkbox checked={authDeleteChecked} onChange={(e) => onAuthAll(e.target.checked, 'authDelete')} />
            <span style={{ marginLeft: '8px' }}>全选</span>
          </div>
        }
      }
    },
  ]
}

export default ({ visible, onClose, onOk, type }) => {
  const [params, setParams] = useState({
    authEdit: [],
    authDelete: []
  })
  const resultData = useAsyncLoading({ fetchData: (_params) => fetchData(_params), params: {} })

  const { data = [], loading } = resultData
  const onAuthChange = (checked, id, key) => {
    if (!key) {
      return
    }
    if (checked) {
      params[key].push(id)
      setParams(pre => ({ ...pre }))
    } else {
      const currentIndex = params[key].findIndex(item => item === id)
      if (currentIndex !== -1) {
        params[key].splice(currentIndex, 1)
        setParams(pre => ({ ...pre }))
      }
    }
  }
  const onAuthAll = (checked, key) => {
    if (checked) {
      params[key] = data.map(item => item.targetUserInfo.userId)
    } else {
      params[key] = data.filter(item => item.targetUserInfo.memberType === 1 || item.targetUserInfo.memberType === 2)
        .map(item => item.targetUserInfo.userId)
    }
    setParams(pre => ({ ...pre }))
  }

  const isFolder = type === 'folder'

  const fetchData = async () => {
    const result = await request.get('/zhikuan/mn/sample/auth/get-user-team-auth')
    if (isFolder) {
      result.forEach(item => {
        item.createAndUpdateFolder && params.authEdit.push(item.targetUserInfo.userId)
        item.moveAndDeleteFolder && params.authDelete.push(item.targetUserInfo.userId)
      })
    } else {
      result.forEach(item => {
        item.operateAndUpdateSample && params.authEdit.push(item.targetUserInfo.userId)
        item.moveAndDeleteSample && params.authDelete.push(item.targetUserInfo.userId)
      })
    }
    setParams(pre => ({ ...pre }))
    return result
  }
  const _onOk = () => {
    saveFolder()
  }

  const saveFolder = async () => {
    const paramsList = data.map(item => {
      const _obj = {}
      if (isFolder) {
        if (params.authEdit.includes(item.targetUserInfo?.userId)) {
          _obj.createAndUpdateFolder = 1
        } else {
          _obj.createAndUpdateFolder = 0
        }
        if (params.authDelete.includes(item.targetUserInfo?.userId)) {
          _obj.moveAndDeleteFolder = 1
        } else {
          _obj.moveAndDeleteFolder = 0
        }
      } else {
        if (params.authEdit.includes(item.targetUserInfo?.userId)) {
          _obj.operateAndUpdateSample = 1
        } else {
          _obj.operateAndUpdateSample = 0
        }
        if (params.authDelete.includes(item.targetUserInfo?.userId)) {
          _obj.moveAndDeleteSample = 1
        } else {
          _obj.moveAndDeleteSample = 0
        }
      }
      _obj.targetUserId = item.targetUserInfo?.userId
      return _obj
    })
    const requestUrl = isFolder ? '/zhikuan/mn/sample/auth/update-folder-auth' : '/zhikuan/mn/sample/auth/update-sample-auth'
    const result = await request.post(requestUrl, paramsList)
    if (result) {
      onOk?.()
      message.success('保存成功')
    }
  }

  return <Modal
    style={{ width: '640px' }}
    visible={visible}
    onClose={onClose}
    onOk={() => _onOk?.()}
    title={`${isFolder ? '权限管理' : '共享编辑'}`}
  >
    <div className={styles['mn-sample-admin-modal']}>
      <Spin spinning={loading}>
        <SimpleTable
          data={data}
          column={() => columns({
            onAuthChange,
            onAuthAll,
            params,
            isFolder,
            authDeleteChecked: params.authDelete.length === data.length,
            authEditChecked: params.authEdit.length === data.length })}
          className="mn-auth-admin-table"
          tbodyStyle={{ height: '432px', overflowY: 'auto' }}
        />
      </Spin>
    </div>
  </Modal>
}
